import { darken, Paper, Box, ListItem, ListItemIcon, ListItemText, Typography, makeStyles, List } from '@material-ui/core';
import { Link, useParams } from 'react-router-dom';
import ContestantsIcon from '@material-ui/icons/People';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const useStyles = makeStyles(theme => ({
    participantList: {
        padding: 0
    },
    participantListItem: {
        '&:hover': {
            backgroundColor: darken(theme.palette.background.paper, 0.2)
        },
    }
}));

// The contestants of the tournament, each one opening their statistics of it
function ParticipantsCard(props) {
    const classes = useStyles();
    const { tournamentId } = useParams();
    const participants = props.participants ?? [];

    if (participants.length === 0) {
        return (
            <Paper elevation={6}>
                <Box p={2}>
                    <Typography> There is no participant </Typography>
                </Box>
            </Paper>
        );
    }
    return (
        <Paper elevation={6}>
            <List className={classes.participantList}>
                <ListItem divider>
                    <ListItemIcon>
                        <ContestantsIcon />
                    </ListItemIcon>
                    <ListItemText
                        disableTypography
                        primary={<Typography variant='h6'> Participants </Typography>}
                        secondary={<Typography variant='body2' color='textSecondary'> Open a participant for their statistics of this tournament </Typography>}
                    />
                </ListItem>
                {participants.map(participant =>
                    <ListItem
                        key={participant}
                        button
                        divider
                        component={Link}
                        to={`/tournament/${tournamentId}/participant/${encodeURIComponent(participant)}`}
                        className={classes.participantListItem}
                    >
                        <ListItemText primary={participant} />
                        <ChevronRightIcon color='disabled' />
                    </ListItem>
                )}
            </List>
        </Paper>
    );
}

export default ParticipantsCard;
